import { render } from "./DevisView.vue?vue&type=template&id=f8046b14&scoped=true"
import script from "./DevisView.vue?vue&type=script&lang=js"
export * from "./DevisView.vue?vue&type=script&lang=js"

import "./DevisView.vue?vue&type=style&index=0&id=f8046b14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8046b14"]])

export default __exports__